import { ORDER_TYPE_ORDER } from 'constants/order'

export const EMPTY_CUSTOMER_INFO = {
  name: '',
  document1: '',
  email: '',
  description: '',
}

export const EMPTY_ORDER = {
  attributes: {
    order_type: ORDER_TYPE_ORDER,
    date: new Date(),
    hour: new Date(),
    sales_channel_id: '',
    customer_info: EMPTY_CUSTOMER_INFO,
  },
}
